import { WaterMark } from './water-mask';
export default WaterMark;